// extracted by css-extract-rspack-plugin
export default {"cls1":"BulkDownloadPing-cls1_U2y","cls2":"BulkDownloadPing-cls2_Fq4 BulkDownloadPing-cls1_U2y"};